import { Skeleton as SkeletonWrapper } from "@mui/material";

interface SkeletonPropsType {
  variant?: "circular" | "rectangular" | "rounded" | "text";
  width?: number | string;
  height?: number | string;
  sx?: any;
}
const Skeleton = ({
  variant = "rectangular",
  width = "auto",
  height = 60,
  sx,
}: SkeletonPropsType) => {
  return (
    <SkeletonWrapper
      variant={variant}
      width={width}
      height={height}
      sx={{ marginBottom: "10px", ...sx }}
    />
  );
};

export default Skeleton;
